import React, { useState,useRef,useEffect } from 'react';
import { useUserAPI } from '../../components/useUserAPI';
import { iAeonCheckSilentMode } from '../../library/iaeon_sdk.js';
import Lottie from 'react-lottie';
import animationData from '../../images/kuji_anim';
import useSound from 'use-sound';
import soundUrl from '../../sound/kuji_lottery.mp3';

//お買物API
import { callOkaimonoAPI } from "../../components/okaimonoAPI";

import styles from '../../styles/KujiLottery.module.scss';

export function KujiLottery(props) {


//----------------------------------------
//初期化
//----------------------------------------

// const ShoppingStartContext = useContext(ShoppingStart);
const { lotteryAPI, data: lotteryData, loading: lotteryLoading, error: lotteryError } = useUserAPI();
// const [prizeList, setPrizeList] = useState()

const [kujiLotterySE] = useSound(soundUrl);

useEffect(() => {
	document.getElementById('header').classList.add('is_behind');

	if (lottieRef && lottieRef.current) {
		if(props.kujiResult.length === 0){
			lotteryAPI(props.shoppingStData.data.transactionno);
			// lottieRef.current.play();
		}
	}

	//arrows We 対応
	// document.documentElement.style.zoom = window.innerWidth / 390;
	// var zratio = window.innerWidth / 390;
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('kuji_anim');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}
}, []);


useEffect(() => {
	//お買物API：画面遷移API（くじ抽選アニメーション画面
	props.okaimonoAPI_didScreenTransition("lottery_animation");
}, []);


//----------------------------------------
//くじ引きAPI
//----------------------------------------

useEffect(() => {
	document.getElementById('header').classList.add('is_behind');

	if(lotteryData){
		if (lotteryData.data) { //SUCCESS

			if (lottieRef && lottieRef.current) {
				if(props.kujiResult.length === 0){
					console.log("lotteryData.data.prizeList:");
					console.log(lotteryData.data.prizeList);
					props.setPrizeList(lotteryData.data.prizeList);
					console.log("くじアニメ再生");
					lottieRef.current.play();
					if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
						//24.サイレントモードチェックAPI
						// callAPI_24();
						//お買物API：サイレントモードチェックAPI << 24.サイレントモードチェックAPI
						okaimonoAPI_checkSilentMode();

					}else if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
						//24.サイレントモードチェックAPI
						callAPI_24();

					}else{ //iAEON無効
						kujiLotterySE();
					}
				}
			}

		}else{ //ERROR
			console.log(`【lotteryAPI】 errorCode: ${lotteryData.errorCode}`);
			console.log(`【lotteryAPI】 errorMessage: ${lotteryData.errorMessage}`);
			console.log(`【lotteryAPI】 isSuccess: ${lotteryData.isSuccess}`);

			// setTimeout(function(){
			// 	if(barcodeCapture){
			// 		barcodeCapture.setEnabled(false);
			// 	}
			// }, 2200);
			if(lotteryData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${lotteryData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${lotteryData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(lotteryData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${lotteryData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${lotteryData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else{
				props.setErrFlg(true);
				props.setErr([true,`${lotteryData.errorCode}`,`${lotteryData.errorMessage}`]);
			}
			// if(payData.errorCode == "26" || payData.errorCode == "27"){
			// 	//トークン不正、トークン有効期限切れ のためアプリ起動後の画面へ（再読込
			// 	window.location.reload();
			// }else{
			// 	props.setErrNum(`${payData.errorCode}`);
			// 	props.setShowModal(true);
			// 	props.setErrTxt(`${payData.errorMessage}`);
			// }
		}
	}
	if(lotteryError){
		console.log("lotteryError");
		console.log(lotteryError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(lotteryLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [lotteryData,lotteryLoading,lotteryError]);


const goKujiList = () => {
	props.setPage("kuji_list")
}

const lottieRef = useRef(null);

const defaultOptions = {
    renderer: 'svg',
    loop: false,
    autoplay: false,
	animationData: animationData
};


const { lotteryhistoryAPI, data: lotteryhistoryData, loading: lotteryhistoryLoading, error: lotteryhistoryError } = useUserAPI();

const [kcount, setKcount] = useState(0);
const [kmax, setKmax] = useState(0);
let ktimer;

useEffect(() => {
	if(props.prizeList){
		if(props.kujiResult.length === 0){

			props.kujiResult.push(1);
			var atimer = setTimeout(function(){
				console.log('【くじ結果表示】');
				console.log(props.prizeList.length);
				console.log(props.prizeList);
				document.getElementById("kujiResult").classList.add('is_show');

				setKcount(1);
				setKmax(props.prizeList.length);
				console.log("kmax: " + props.prizeList.length);
				showKujiResult(1,props.prizeList.length);

			}, 4400);
		}
	}
}, [props.prizeList]);

const showKujiResult = (kkcount,kkmax) => {
	// var kcount = 2;
	// var kmax = 5;
	// var kcount = 2;
	// var kmax = props.prizeList.length;
	// console.log("kkcount: " + kkcount);
	// console.log("kkmax: " + kkmax);
	if(kkmax === 1){
		// document.getElementById("kuji_r1").classList.add('is_active');
		// document.getElementById("kuji_r1").classList.remove('is_active');
		if(document.getElementById("kuji_r1")){
			document.getElementById("kuji_r1").classList.add('is_last');
			clearInterval(ktimer);
			var stimer = setTimeout(function(){
				// goKujiList();
				lotteryhistoryAPI();
			},3000);
		}
	}else {
		if(kkcount > 1){
			var ta_old = "kuji_r"+(kkcount-1);
			if(document.getElementById(ta_old)){
				document.getElementById(ta_old).classList.add('is_hide');
			}
		}
		var ta_new = "kuji_r"+kkcount;
		if(kkcount === kkmax){
			if(document.getElementById(ta_new)){
				document.getElementById(ta_new).classList.add('is_last');
				clearInterval(ktimer);
				var stimer = setTimeout(function(){
					// goKujiList();
					lotteryhistoryAPI();
				},3000);
			}
		}else if(kkcount < kkmax){
			if(document.getElementById(ta_new)){
				document.getElementById(ta_new).classList.add('is_active');
				// kcount += 1;
				setKcount(kkcount+1);
				ktimer = setInterval(function(){
					showKujiResult(kkcount+1,kkmax);
				}, 3000);
			}
		}
	}
}

const skipKujiResult = () => {
	if(kcount !== 0){
		clearInterval(ktimer);
		if(kcount > 1){
			var ta_old = "kuji_r"+(kcount-1);
			if(document.getElementById(ta_old)){
				document.getElementById(ta_old).classList.add('is_hide');
			}
		}
		console.log("kcount: " + kcount);
		console.log("kmax: " + kmax);
		var ta_new = "kuji_r"+kcount;
		if(kcount < kmax){
			if(document.getElementById(ta_new)){
				document.getElementById(ta_new).classList.add('is_skip');
				// kcount += 1;
				setKcount(kcount+1);
				ktimer = setInterval(function(){
					showKujiResult(kcount,kmax);
				}, 3000);
				props.setSoundState("se08_se");
			}
		}else {
			if(document.getElementById(ta_new)){
				document.getElementById(ta_new).classList.add('is_skip');
				document.getElementById(ta_new).classList.add('is_last');
				clearInterval(ktimer);
				var stimer = setTimeout(function(){
					// goKujiList();
					lotteryhistoryAPI();
				},1400);
				props.setSoundState("se08_se");
			}
		}
	}
}


useEffect(() => {
	if(lotteryhistoryData){
		if (lotteryhistoryData.data) { //SUCCESS
			console.log("抽出前: ");
			console.log(lotteryhistoryData.data.prizeList);

			// const prizeList = [
			// 	{transactionno: 49965, number: 1, lotteryResult: 0, prizeName: "", prizeImg: "https://dev-image.irs-test.jp/promotion/lose.png"},
			// 	{transactionno: 49965, number: 2, lotteryResult: 1, prizeName: "飲料もしくはお菓子いずれか１つ", prizeImg: "https://dev-image.irs-test.jp/promotion/3rd.png"},
			// 	{transactionno: 49965, number: 3, lotteryResult: 1, prizeName: "飲料もしくはお菓子いずれか１つ", prizeImg: "https://dev-image.irs-test.jp/promotion/3rd.png"}
			// ];

			// const filteredPrizeList = lotteryhistoryData.data.prizeList.filter(item => item.lotteryResult !== 0);
			const filteredPrizeList = lotteryhistoryData.data.prizeList.filter(item => item.lotteryResult !== 0 && item.transactionno === props.shoppingStData.data.transactionno);

			console.log("抽出後: ");
			console.log(filteredPrizeList);

			// props.setPrizeList(lotteryhistoryData.data.prizeList);
			props.setPrizeList(filteredPrizeList);

			// var stimer = setTimeout(function(){
			goKujiList();
			// },300);

		}else{ //ERROR
			console.log(`【lotteryhistoryAPI】 errorCode: ${lotteryhistoryData.errorCode}`);
			console.log(`【lotteryhistoryAPI】 errorMessage: ${lotteryhistoryData.errorMessage}`);
			console.log(`【lotteryhistoryAPI】 isSuccess: ${lotteryhistoryData.isSuccess}`);

			// if(payData.errorCode == "26" || payData.errorCode == "27"){
			// 	//トークン不正、トークン有効期限切れ のためアプリ起動後の画面へ（再読込
			// 	window.location.reload();
			// }else{
			// 	props.setErrNum(`${payData.errorCode}`);
			// 	props.setShowModal(true);
			// 	props.setErrTxt(`${payData.errorMessage}`);
			// }
			if(lotteryhistoryData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${lotteryhistoryData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${lotteryhistoryData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(lotteryhistoryData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${lotteryhistoryData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${lotteryhistoryData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else{
				props.setErrFlg(true);
				// props.setErr([true,`${lotteryhistoryData.errorCode}`,`${lotteryhistoryData.errorMessage}`]);
				props.setErr([true,`999`,`${lotteryhistoryData.errorMessage}`]);
			}
		}
	}
	if(lotteryhistoryError){
		console.log("lotteryhistoryError");
		console.log(lotteryhistoryError);
		props.setErrFlg(true);
		props.setErr([true, process.env.REACT_APP_ERROR_CODE_999, process.env.REACT_APP_ERROR_MESSAGE_999]);
		// props.setErr([true,`999`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,`999`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(lotteryhistoryLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [lotteryhistoryData,lotteryhistoryLoading,lotteryhistoryError]);


//----------------------------------------
// iAEON API：24.サイレントモードチェックAPI
//----------------------------------------

function callAPI_24(){
    let successCall_24 = function(success){
        var aaa = success;
		console.log('【iAeonCheckSilentMode】success：' + aaa);
		console.log('【iAeonCheckSilentMode】is_silent_mode：' + aaa.is_silent_mode);

		if(aaa.is_silent_mode != true){
			kujiLotterySE();
		}
    }
    let errorCall_24 = function(error){
		console.log('【iAeonCheckSilentMode】error: ' + error.error_code + " : " + error.message);
    }
	console.log("----------------------------");
	console.log('【iAeonCheckSilentMode】call');
    iAeonCheckSilentMode().then(successCall_24).catch(errorCall_24);
}


//----------------------------------------
//お買物API：サイレントモードチェックAPI << 24.サイレントモードチェックAPI
//----------------------------------------

const okaimonoAPI_checkSilentMode = async () => {
	try {
		console.log("----------------------------");
		console.log("【checkSilentMode】call");
		const { callbackId, result } = await callOkaimonoAPI('checkSilentMode');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【checkSilentMode】success", result);
			console.log("【checkSilentMode】result:", result.result);
			console.log("【checkSilentMode】status:", result.status);

			if(result.status === "0"){ //サイレントモードOFF
				kujiLotterySE();
			}

		}else {
			console.log("【checkSilentMode】error", result);
			console.log("【checkSilentMode】result:", result.result);
		}

	} catch (error) {
		console.log('【checkSilentMode】error', error);
	}
};


return (
	<>

	{
		(() => {
			if (lotteryData && lotteryData.data) {
			return(
				<div id="kuji_anim" className={styles.kujiLottery}>
				<Lottie
					options={defaultOptions}
					width={390}
					height={694}
					ref={lottieRef}
					// eventListeners={[{
					// 	eventName: 'complete',
					// 	callback: onAnimationComp
					// }]}
				>
				</Lottie>
				</div>
			)
			}else{
				return(
					<div id="kuji_anim" className={styles.kujiLottery}>
					<Lottie
						options={defaultOptions}
						width={390}
						height={694}
						ref={lottieRef}
						// eventListeners={[{
						// 	eventName: 'complete',
						// 	callback: onAnimationComp
						// }]}
						style={{display:"none"}}
					>
					</Lottie>
					</div>
				)
			}
		})()
	}

	<section id="kujiResult" className="modalBox kujiModal" onClick={skipKujiResult}>
	<div className="modalBox_wrap">
	{
		(() => {
			if (props.prizeList) {
			return(
					props.prizeList.length > 0 &&
					props.prizeList.map((item, index) => (
						<div id={`kuji_r${index+1}`} key={index} className={`kujiResult ${item.lotteryResult === 0 ? 'kujiResult_lose' : ''}`}>
							<img src={item.prizeImg} alt="" width="333" height="453" />
						</div>
					))
			)
			}
		})()
	}
		{/* <div id="kuji_r1" className="kujiResult">
			<img src="/images/kuji/kuji_result01.svg" alt="" width="333" height="453" />
		</div>
		<div id="kuji_r2" className="kujiResult">
			<img src="/images/kuji/kuji_result02.svg" alt="" width="333" height="453" />
		</div>
		<div id="kuji_r3" className="kujiResult kujiResult_lose">
			<img src="/images/kuji/kuji_result05.svg" alt="" width="333" height="453" />
		</div>
		<div id="kuji_r4" className="kujiResult">
			<img src="/images/kuji/kuji_result04.svg" alt="" width="333" height="453" />
		</div>
		<div id="kuji_r5" className="kujiResult kujiResult_lose">
			<img src="/images/kuji/kuji_result05.svg" alt="" width="333" height="453" />
		</div> */}
	</div>
	<div className="modalBox_cover kujiModal_cover"></div>
</section>
	{/* <section id="kujiResult" className={`modalBox ${styles.kujiModal}`}>
		<div className="modalBox_wrap">
			<div id="kuji_r1" className={styles.kujiResult}>
				<img src="/images/kuji/kuji_result01.svg" alt="" width="333" height="453" />
			</div>
			<div id="kuji_r2" className={styles.kujiResult}>
				<img src="/images/kuji/kuji_result02.svg" alt="" width="333" height="453" />
			</div>
			<div id="kuji_r3" className={`${styles.kujiResult} ${styles.kujiResult_lose}`}>
				<img src="/images/kuji/kuji_result05.svg" alt="" width="333" height="453" />
			</div>
			<div id="kuji_r4" className={styles.kujiResult}>
				<img src="/images/kuji/kuji_result04.svg" alt="" width="333" height="453" />
			</div>
			<div id="kuji_r5" className={`${styles.kujiResult} ${styles.kujiResult_lose}`}>
				<img src="/images/kuji/kuji_result05.svg" alt="" width="333" height="453" />
			</div>
		</div>
	</section> */}
	</>
)

}
